export const IS_DESKTOP = import.meta.env.VITE_APP_TARGET === 'desktop';
export const PUBLIC_ENTRY_PATH = IS_DESKTOP ? '/login' : '/home';
